"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvoiceStatusLabel = getInvoiceStatusLabel;
exports.getContractorInvoiceStatusLabel = getContractorInvoiceStatusLabel;
exports.getInvoiceStatusBadge = getInvoiceStatusBadge;
exports.getContractorInvoiceStatusBadge = getContractorInvoiceStatusBadge;
exports.invoiceStatusOptions = exports.documentTypeOptions = exports.documentTypes = exports.contractorInvoiceStatusBadge = exports.invoiceStatusBadge = exports.contractorInvoiceStatusLabels = exports.invoiceStatusLabels = exports.invoiceStatus = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _invoiceStatusLabels, _objectSpread2, _invoiceStatusBadge, _objectSpread3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var invoiceStatus = {
  DELETED: 'deleted',
  ISSUED: 'issued',
  PAID_IN: 'paid_in',
  PAID_OUT: 'paid_out',
  REJECTED: 'rejected',
  ENQUEUED: 'enqueued',
  PROCESSING: 'processing',
  PENDING_PAYMENT: 'pending_payment',
  PAY_IN_FAILED: 'pay_in_failed',
  PAY_OUT_FAILED: 'pay_out_failed'
};
exports.invoiceStatus = invoiceStatus;
var invoiceStatusLabels = (_invoiceStatusLabels = {}, (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.DELETED, 'Deleted'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.ISSUED, 'Issued'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PAID_IN, 'Paid In'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PAID_OUT, 'Paid Out'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.REJECTED, 'Rejected'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.ENQUEUED, 'Enqueued'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PROCESSING, 'Processing'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PENDING_PAYMENT, 'Pending Payment'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PAY_IN_FAILED, 'Pay In Failed'), (0, _defineProperty2["default"])(_invoiceStatusLabels, invoiceStatus.PAY_OUT_FAILED, 'Pay Out Failed'), _invoiceStatusLabels);
exports.invoiceStatusLabels = invoiceStatusLabels;

var contractorInvoiceStatusLabels = _objectSpread(_objectSpread({}, invoiceStatusLabels), {}, (_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, invoiceStatus.ENQUEUED, invoiceStatusLabels[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread2, invoiceStatus.PROCESSING, invoiceStatusLabels[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread2, invoiceStatus.PAID_IN, invoiceStatusLabels[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread2, invoiceStatus.PAY_IN_FAILED, invoiceStatusLabels[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread2, invoiceStatus.PAY_OUT_FAILED, invoiceStatusLabels[invoiceStatus.PENDING_PAYMENT]), _objectSpread2));

exports.contractorInvoiceStatusLabels = contractorInvoiceStatusLabels;
var invoiceStatusBadge = (_invoiceStatusBadge = {}, (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.DELETED, 'inactive'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.ISSUED, 'pending'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PAID_IN, 'info'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PAID_OUT, 'active'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.REJECTED, 'inactive'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.ENQUEUED, 'pending'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PROCESSING, 'pending'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PENDING_PAYMENT, 'pending'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PAY_IN_FAILED, 'attention'), (0, _defineProperty2["default"])(_invoiceStatusBadge, invoiceStatus.PAY_OUT_FAILED, 'error'), _invoiceStatusBadge);
exports.invoiceStatusBadge = invoiceStatusBadge;

var contractorInvoiceStatusBadge = _objectSpread(_objectSpread({}, invoiceStatusBadge), {}, (_objectSpread3 = {}, (0, _defineProperty2["default"])(_objectSpread3, invoiceStatus.ENQUEUED, invoiceStatusBadge[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread3, invoiceStatus.PROCESSING, invoiceStatusBadge[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread3, invoiceStatus.PAID_IN, invoiceStatusBadge[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread3, invoiceStatus.PAY_IN_FAILED, invoiceStatusBadge[invoiceStatus.PENDING_PAYMENT]), (0, _defineProperty2["default"])(_objectSpread3, invoiceStatus.PAY_OUT_FAILED, invoiceStatusBadge[invoiceStatus.PENDING_PAYMENT]), _objectSpread3));

exports.contractorInvoiceStatusBadge = contractorInvoiceStatusBadge;
var documentTypes = {
  CONTRACTOR: 'contractor',
  PAYROLL_RUN: 'payroll_run'
};
exports.documentTypes = documentTypes;
var documentTypeOptions = [{
  value: documentTypes.PAYROLL_RUN,
  label: 'Invoice'
}, {
  value: documentTypes.CONTRACTOR,
  label: 'Transaction Receipt'
}];
exports.documentTypeOptions = documentTypeOptions;
var invoiceStatusOptions = Object.entries(invoiceStatusLabels).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];

  return {
    value: value,
    label: label
  };
});
exports.invoiceStatusOptions = invoiceStatusOptions;

function getInvoiceStatusLabel(statusKey) {
  return invoiceStatusLabels[statusKey];
}

function getContractorInvoiceStatusLabel(statusKey) {
  return contractorInvoiceStatusLabels[statusKey];
}

function getInvoiceStatusBadge(statusKey) {
  return invoiceStatusBadge[statusKey];
}

function getContractorInvoiceStatusBadge(statusKey) {
  return contractorInvoiceStatusBadge[statusKey];
}